import React, { Component } from "react";
import { Modal, Button, Image, Table, Segment } from "semantic-ui-react";

class Person extends Component {
  componentDidMount() {}
  render() {
    const rows = [];
    if (this.props.dialogProps.data && this.props.dialogProps.data !== "") {
      rows.push(
        <Table.Row key={"row_per_zip"}>
          <Table.Cell className={"table-border-right-line"}>
            Zipcode:
          </Table.Cell>
          <Table.Cell>{this.props.dialogProps.zip}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={"row_per_city"}>
          <Table.Cell className={"table-border-right-line"}>City:</Table.Cell>
          <Table.Cell>{this.props.dialogProps.city}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={"row_per_state"}>
          <Table.Cell className={"table-border-right-line"}>State:</Table.Cell>
          <Table.Cell>{this.props.dialogProps.state}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={"row_per_data"}>
          <Table.Cell className={"table-border-right-line"}>
            {this.props.dialogProps.dataLabel}:
          </Table.Cell>
          <Table.Cell>{this.props.dialogProps.data}</Table.Cell>
        </Table.Row>
      );
    } else {
      rows.push(
        <Table.Row key={"row_per_no_rec"}>
          <Table.Cell colSpan={2}>No record found</Table.Cell>
        </Table.Row>
      );
    }
    return (
      this.props.dialogProps && (
        <Modal
          className={"dialog-person-render"}
          // size={"tiny"}
          trigger={
            this.props.source
            // <Button style={{ backgroundColor: "none" }}>Coverage</Button>
          }
          closeIcon
          open={this.props.active}
          onClose={() => this.props.dialogClose(this)}
        >
          <Modal.Header className="report-name-header">
            {this.props.loading && "Loading..."}
            {!this.props.loading && this.props.dialogProps.title}
          </Modal.Header>
          <Modal.Content image scrolling>
            <Segment
              loading={this.props.loading}
              className="home-dialog-segment"
            >
              {this.props.loading && <div style={{ height: "200px" }} />}
              {!this.props.loading && (
                <Table className="table-no-border">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell width={4}>
                        <Image
                          className="home-dialog-image"
                          wrapped
                          src={this.props.dialogProps.imageUrl}
                        />
                      </Table.Cell>
                      <Table.Cell width={12}>
                        <Table>
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell
                                colSpan={2}
                                className={
                                  "text-center table-cell-border-bottom"
                                }
                              >
                                {this.props.dialogProps.tableHeader}
                              </Table.Cell>
                            </Table.Row>
                            {rows}
                          </Table.Body>
                        </Table>
                        {this.props.dialogProps.data &&
                          this.props.dialogProps.data !== "" &&
                          this.props.dialogProps.note}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              )}
            </Segment>
          </Modal.Content>
          <Modal.Actions className={"dialog-actions"}>
            <Button
              className={"no-background-color float-right"}
              onClick={() => this.props.dialogClose(this)}
            >
              Done
            </Button>
          </Modal.Actions>
        </Modal>
      )
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/components/dialogs/person.js